/**
 * TDS · PUENTE TEMPORAL: el regalo del carrito, UNA SOLA UNIDAD.
 *
 * Dos cosas, las dos sobre la línea que el carrito regala al llegar a la meta:
 *
 *   1. Se le quita el botón de «+»: con él, el cliente podía pedir tres
 *      llaveros de regalo y el carrito se los daba igual, a 0 €.
 *   2. Si en el carrito aparece más de uno —da igual quién lo haya puesto—,
 *      se deja uno y se retiran los demás. En el pedido #PEDIDO18333 llegaron
 *      CINCO líneas del mismo llavero de regalo; cuatro de ellas arrastraban
 *      la personalización del cuadro, así que no venían del cajón sino del
 *      botón de comprar de la ficha. Por eso el tope se pone aquí, sobre el
 *      carrito ya hecho: cubre cualquier camino de entrada, incluidos los
 *      carritos que ya estén así desde ayer.
 *   3. Y el regalo SIGUE A SU META. El cajón lo pone al llegar al importe,
 *      pero no lo quitaba al bajar de él: vaciando el carrito quedaba el
 *      llavero solo, a 0 €, con la barra diciendo que faltaban 30 € para el
 *      envío gratis. Ahora se mira en cada cambio: si el carrito —sin contar
 *      los regalos— llega al importe, hay uno; si no llega, no hay ninguno.
 *
 * El arreglo de (1) ya está escrito DENTRO de la app del cajón, pero esa app
 * no se puede publicar desde este equipo. Esto lo cubre mientras tanto.
 *
 * QUITAR cuando se publique la app:
 *     shopify app deploy --config carrito-lateral
 * y borrar luego su línea del layout. Ojo: el tope de (2) NO lo hace la app
 * todavía; si se retira esto, hay que llevárselo allí.
 *
 * Sin console.log.
 */
(function () {
  'use strict';

  var TDS_L = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || "").slice(0, 2);

  var CONFIG = '/apps/carrito/config';
  var AVISO = TDS_L === "de" ? "Das ist ein Geschenk: nur ein Stück pro Bestellung" : TDS_L === "en" ? "It's a gift: limit one per order" : TDS_L === "it" ? "È un regalo: una sola unità per ordine" : 'Es un regalo: una unidad por pedido';

  var handles = null;     // productos que el carrito regala al llegar a su meta
  var pendiente = null;
  var trabajando = false;

  function pedir(url, opciones) {
    return fetch(url, opciones || { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /**
   * Los regalos automáticos del panel, cada uno con SU importe en céntimos:
   * `[{ handle, umbral }]`.
   */
  function cargarRegalos() {
    if (handles) return Promise.resolve(handles);
    return pedir(CONFIG).then(function (d) {
      var envio = (d && (d.envio || (d.ajustes && d.ajustes.envio))) || {};
      handles = (envio.metas || [])
        .filter(function (m) { return m && m.tipo === 'producto' && m.autoAnadir && m.handle; })
        .map(function (m) {
          return { handle: m.handle, umbral: Math.round(Number(m.importe || 0) * 100) };
        });
      return handles;
    });
  }

  function listaDeHandles(hs) {
    return hs.map(function (m) { return m.handle; });
  }

  /**
   * ¿Esta línea es un REGALO del carrito?
   *
   * No vale con mirar el producto: ese mismo llavero comprado a propósito es
   * una línea normal y sus botones tienen que seguir funcionando. Se mira que
   * sea uno de los productos que se regalan Y que no se esté cobrando —o que
   * lleve la marca que le pone el cajón—.
   */
  function esRegalo(it, hs) {
    if (listaDeHandles(hs).indexOf(it.handle) === -1) return false;
    return !!(it.properties && it.properties._regalo) || it.final_line_price === 0;
  }

  /** Lo que el cliente lleva de verdad, sin contar lo que se le regala. */
  function totalSinRegalos(items, hs) {
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      if (!esRegalo(items[i], hs)) total += items[i].final_line_price || 0;
    }
    return total;
  }

  /** Pone el regalo que toca, marcado para poder reconocerlo luego. */
  function ponerRegalo(handle) {
    // El producto se pide SIN prefijo de idioma: con él (`/en/products/…`)
    // la tienda responde 404 y el regalo no llegaba a entrar nunca.
    return pedir('/products/' + encodeURIComponent(handle) + '.js').then(function (p) {
      var v = p && p.variants && p.variants[0];
      if (!v) return false;
      return pedir('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1, properties: { _regalo: '1' } }),
      }).then(function () { return true; });
    });
  }

  /**
   * Deja UN regalo y retira los que sobren. Con `ninguno`, los retira todos
   * —que es lo que toca cuando el carrito ha bajado de la meta—. Devuelve si
   * ha tocado algo.
   */
  function dejarUno(regalos, ninguno) {
    var cambios = [];
    for (var i = 0; i < regalos.length; i++) {
      if (i === 0 && !ninguno) {
        if (regalos[i].quantity > 1) cambios.push({ id: regalos[i].key, quantity: 1 });
      } else {
        cambios.push({ id: regalos[i].key, quantity: 0 });
      }
    }
    if (!cambios.length) return Promise.resolve(false);
    // De uno en uno: el carrito de Shopify recoloca las líneas en cada
    // cambio, y en paralelo se pisarían las claves.
    return cambios.reduce(function (cadena, c) {
      return cadena.then(function () {
        return pedir('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(c),
        });
      });
    }, Promise.resolve()).then(function () { return true; });
  }

  /** Apaga el «+» de las líneas de regalo que haya pintadas. */
  function apagarBotones(regalos) {
    for (var i = 0; i < regalos.length; i++) {
      var b = document.querySelector('[data-cd-mas="' + regalos[i].key + '"]');
      if (!b || b.disabled) continue;
      b.disabled = true;
      b.title = AVISO;
      b.setAttribute('aria-label', AVISO);
    }
  }

  function repasar() {
    if (trabajando) return;
    trabajando = true;
    cargarRegalos().then(function (hs) {
      if (!hs.length) return null;
      return pedir('/cart.js').then(function (c) {
        if (!c || !c.items) return null;
        var gastado = totalSinRegalos(c.items, hs);
        var tareas = [];
        for (var i = 0; i < hs.length; i++) {
          var meta = hs[i];
          var suyas = c.items.filter(function (it) {
            return esRegalo(it, hs) && it.handle === meta.handle;
          });
          apagarBotones(suyas);
          if (gastado >= meta.umbral && meta.umbral > 0) {
            // Meta cumplida: uno, ni más ni menos.
            if (!suyas.length) tareas.push(ponerRegalo(meta.handle));
            else tareas.push(dejarUno(suyas));
          } else if (suyas.length) {
            // Ya no se llega: el regalo se retira entero.
            tareas.push(dejarUno(suyas, true));
          }
        }
        if (!tareas.length) return null;
        return Promise.all(tareas).then(function (r) {
          return r.some(function (x) { return !!x; });
        });
      });
    }).then(function (tocado) {
      trabajando = false;
      if (!tocado) return;
      // El cajón tiene que enterarse de que su carrito ya no es el que tenía.
      try {
        if (window.CarritoLateral && window.CarritoLateral.refrescar) window.CarritoLateral.refrescar();
        else document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (e) { /* el cajón aún no ha arrancado */ }
    }, function () { trabajando = false; });
  }

  function programar() {
    if (pendiente) clearTimeout(pendiente);
    pendiente = setTimeout(function () { pendiente = null; repasar(); }, 200);
  }

  // Al cargar, y cada vez que algo toca el carrito.
  ['cart:refresh', 'cart:open', 'cart:update', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, programar);
  });

  if ('MutationObserver' in window) {
    var vigilar = function () {
      if (!document.body) return;
      // El cajón repinta su lista entera en cada cambio, así que una vez no
      // basta. Se vigila el ÁRBOL, no los atributos: apagar el botón es un
      // cambio de atributo y volvería a disparar esto sin parar.
      new MutationObserver(programar).observe(document.body, { childList: true, subtree: true });
      programar();
    };
    if (document.body) vigilar();
    else document.addEventListener('DOMContentLoaded', vigilar);
  }
})();
